



















































































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  PostEva,
  PostAll,
  PostStatsMonth,
  PostStatsHospital,
  PostStatsTizhi,
  PostStatsNeirong,
  PostStatsPopulation,
  GetDapinData,
  getTongueFeature
} from "@/request/differences";

const MONTHS = [
  "一月",
  "二月",
  "三月",
  "四月",
  "五月",
  "六月",
  "七月",
  "八月",
  "九月",
  "十月",
  "十一月",
  "十二月",
];
const EVA_MONTH_KEYS = [
  "janCount",
  "febCount",
  "marCount",
  "aprCount",
  "mayCount",
  "junCount",
  "julCount",
  "augCount",
  "septCount",
  "octCount",
  "novCount",
  "decCount",
];
const TIZHI_COLOR_MAP: any = {
  平和质: "#2ec7c9",
  气虚质: "#9fd35f",
  阳虚质: "#d4e157",
  阴虚质: "#ffc107",
  痰湿质: "#ff9800",
  湿热质: "#ff6b4a",
  气郁质: "#ec407a",
  血瘀质: "#ab47bc",
  特禀质: "#5c6bc0",
};
const TIZHI_FALLBACK = [
  "#2ec7c9",
  "#9fd35f",
  "#d4e157",
  "#ffc107",
  "#ff9800",
  "#ff6b4a",
  "#ec407a",
  "#ab47bc",
  "#5c6bc0",
];
const FEATURE_KEYS = ["舌形", "舌色", "苔色", "苔质"];
const FEATURE_COLORS: any = {
  舌形: "#5ce1e6",
  舌色: "#ff7b93",
  苔色: "#f7c948",
  苔质: "#7a6cff",
};
const AGE_COLORS = ["#5ce1e6", "#4db8e8", "#5b8cff", "#7a6cff", "#9b5cff", "#c45cff"];

@Component({})
export default class KanbanDaping extends Vue {
  private nowTime = new Date();
  private updateTime = new Date();
  private interval: any = null;
  private refreshTimer: any = null;
  private statYear: number = new Date().getFullYear();
  private trendKey = 0;
  private feedPaused = false;
  private kpi: any = {
    totalService: 0,
    monthService: 0,
    dayService: 0,
    totalAssess: 0,
    hospital: 0,
    tizhiCount: 0,
  };
  private trendOption: any = {};
  private tizhiOption: any = {};
  private tizhiLegend: any[] = [];
  private featureGroups: any[] = [];
  private ageOption: any = {};
  private genderOption: any = {};
  private genderPercents: any = { male: 0, female: 0 };
  private hasTrend = false;
  private hasAge = false;
  private hasGender = false;
  private messagesList: any[] = [];
  private loading: any = {
    kpi: true,
    trend: true,
    feed: true,
    people: true,
    tizhi: true,
    feature: true,
  };

  private get user() {
    return this.$store.state.user || {};
  }
  private get pageTitle() {
    return this.user["姓名"] || "治未病数据平台";
  }
  private get space() {
    return (window.innerHeight / 768) * 16 + "px";
  }
  private get titleLineHeight() {
    return (window.innerHeight / 768) * 60 + "px";
  }
  private get yearOptions() {
    const year = new Date().getFullYear();
    return [year, year - 1, year - 2, year - 3, year - 4];
  }
  private get nowText() {
    const d = this.nowTime;
    const pad = (n: number) => (n < 10 ? "0" + n : "" + n);
    return (
      d.getFullYear() +
      "年" +
      (d.getMonth() + 1) +
      "月" +
      d.getDate() +
      "日 " +
      pad(d.getHours()) +
      ":" +
      pad(d.getMinutes())
    );
  }
  private get updateText() {
    const d = this.updateTime;
    const pad = (n: number) => (n < 10 ? "0" + n : "" + n);
    return pad(d.getHours()) + ":" + pad(d.getMinutes());
  }
  private get kpiList() {
    return [
      { key: "totalService", label: "服务总人次", value: this.kpi.totalService },
      { key: "monthService", label: "本月服务人次", value: this.kpi.monthService },
      { key: "dayService", label: "今日服务人次", value: this.kpi.dayService },
      { key: "totalAssess", label: "总测评量", value: this.kpi.totalAssess },
      { key: "hospital", label: "接入机构", value: this.kpi.hospital },
      { key: "tizhi", label: "体质辨识人数", value: this.kpi.tizhiCount },
    ];
  }
  private get feedLoopList() {
    if (this.messagesList.length > 5) {
      return this.messagesList.concat(this.messagesList);
    }
    return this.messagesList;
  }
  private baseParams() {
    return {
      hospital_ids: [],
      doctor_id: [],
    };
  }
  private goBack() {
    this.$router.back();
  }
  private goMore() {
    this.$router.push("/main/datacenter/pool/pool-list");
  }
  private maskName(name: any) {
    const s = String(name || "").trim();
    if (!s) {
      return "***";
    }
    if (s.length === 1) {
      return s + "*";
    }
    if (s.length === 2) {
      return s[0] + "*";
    }
    return s[0] + "*" + s[s.length - 1];
  }
  private formatMsgTime(val: any) {
    if (!val) {
      return "";
    }
    const matched = String(val).match(/(\d{2}:\d{2}:\d{2})/);
    if (matched) {
      return matched[1];
    }
    const d = new Date(val);
    if (isNaN(d.getTime())) {
      return String(val);
    }
    const pad = (n: number) => (n < 10 ? "0" + n : "" + n);
    return pad(d.getHours()) + ":" + pad(d.getMinutes()) + ":" + pad(d.getSeconds());
  }
  private toNumber(val: any) {
    const n = Number(val);
    return isNaN(n) ? 0 : n;
  }
  private pickRatio(item: any, total: number) {
    if (!total) {
      return 0;
    }
    const fromValue = (this.toNumber(item && item.value) / total) * 100;
    if (item && item.ratio !== undefined && item.ratio !== null && item.ratio !== "") {
      const r = this.toNumber(item.ratio);
      if (r > 0) {
        return r > 1 ? Math.round(r) : Math.round(r * 100);
      }
    }
    return Math.round(fromValue);
  }
  private axisText() {
    return {
      color: "#7aa0c4",
      fontSize: 11,
    };
  }
  private getAssessKpi() {
    return PostAll(this, this.baseParams()).then((res: any) => {
      const data = res || {};
      this.kpi.totalAssess = this.toNumber(data["总测评量"]);
    });
  }
  private getHospitalCount() {
    return PostStatsHospital(this, {
      ...this.baseParams(),
      人群: "全部",
      统计时间: "全部时间",
    }).then((res: any) => {
      const list = (res && res["柱状图"] && res["柱状图"].data) || [];
      this.kpi.hospital = list.length;
    });
  }
  private getServiceKpi() {
    return PostEva(this, {
      ...this.baseParams(),
      year: new Date().getFullYear(),
    }).then((res: any) => {
      const data = res || {};
      this.kpi.totalService = this.toNumber(data.totalCount);
      this.kpi.monthService = this.toNumber(data.monthCount);
      this.kpi.dayService = this.toNumber(data.dayCount);
    });
  }
  private getTrend() {
    this.loading.trend = true;
    this.hasTrend = false;
    const evaParams: any = {
      ...this.baseParams(),
      year: this.statYear,
    };
    const monthParams: any = {
      ...this.baseParams(),
      year: this.statYear,
    };
    return Promise.all([
      PostEva(this, evaParams),
      PostStatsMonth(this, monthParams),
    ]).then(([eva, month]: any[]) => {
      const evaData = eva || {};
      const serviceData = EVA_MONTH_KEYS.map((key) => this.toNumber(evaData[key]));
      const monthTitles = (month && month.title) || MONTHS;
      const monthRaw = (month && month.data) || [];
      const assessData = MONTHS.map((label, index) => {
        const hit = monthRaw[index];
        if (typeof hit === "number") {
          return hit;
        }
        if (hit && hit.value !== undefined) {
          return this.toNumber(hit.value);
        }
        const byName = monthRaw.find((item: any) => item && (item.name === label || item.title === label));
        return this.toNumber(byName && byName.value);
      });
      const sum = serviceData.concat(assessData).reduce((s, n) => s + n, 0);
      this.hasTrend = sum > 0;
      this.trendOption = this.buildTrendOption(monthTitles.length === 12 ? monthTitles : MONTHS, serviceData, assessData);
      this.trendKey += 1;
    }).catch(() => {
      this.hasTrend = false;
    }).then(() => {
      this.loading.trend = false;
    });
  }
  private buildTrendOption(titles: string[], serviceData: number[], assessData: number[]) {
    return {
      tooltip: {
        trigger: "axis",
        backgroundColor: "rgba(6,20,40,0.92)",
        borderColor: "#1a6bb5",
        textStyle: { color: "#d7ecff", fontSize: 12 },
      },
      legend: {
        show: false,
      },
      grid: {
        left: 46,
        right: 18,
        top: 28,
        bottom: 28,
      },
      xAxis: {
        type: "category",
        data: titles,
        boundaryGap: false,
        axisTick: { show: false },
        axisLine: { lineStyle: { color: "rgba(80,140,200,0.35)" } },
        axisLabel: this.axisText(),
      },
      yAxis: {
        type: "value",
        minInterval: 1,
        splitLine: { lineStyle: { color: "rgba(80,140,200,0.12)" } },
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: this.axisText(),
      },
      series: [
        {
          name: "服务人次",
          type: "line",
          smooth: true,
          symbol: "circle",
          symbolSize: 7,
          label: { show: true, color: "#5ce1e6", fontSize: 11 },
          lineStyle: { width: 2, color: "#5ce1e6" },
          itemStyle: { color: "#5ce1e6", borderColor: "#08304a", borderWidth: 1 },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "rgba(92,225,230,0.32)" },
                { offset: 1, color: "rgba(92,225,230,0.02)" },
              ],
            },
          },
          data: serviceData,
        },
        {
          name: "测评量",
          type: "line",
          smooth: true,
          symbol: "circle",
          symbolSize: 7,
          label: { show: true, color: "#5b8cff", fontSize: 11 },
          lineStyle: { width: 2, color: "#4a7dff" },
          itemStyle: { color: "#4a7dff", borderColor: "#08304a", borderWidth: 1 },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "rgba(74,125,255,0.28)" },
                { offset: 1, color: "rgba(74,125,255,0.02)" },
              ],
            },
          },
          data: assessData,
        },
      ],
    };
  }
  private getTizhi() {
    this.loading.tizhi = true;
    const params: any = {
      ...this.baseParams(),
      统计时间: "全部时间",
      测评类型: "中医体质辨识",
    };
    return PostStatsTizhi(this, params).then((res: any) => {
      const list = ((res && res.data) || []).map((item: any, index: number) => {
        const name = item.title || item.name || "";
        return {
          name,
          value: this.toNumber(item.value),
          ratio: item.ratio,
          itemStyle: {
            color: TIZHI_COLOR_MAP[name] || TIZHI_FALLBACK[index % TIZHI_FALLBACK.length],
          },
        };
      });
      const total = list.reduce((s: number, item: any) => s + item.value, 0);
      this.kpi.tizhiCount = total;
      const sorted = list.slice().sort((a: any, b: any) => b.value - a.value);
      this.tizhiLegend = sorted.map((item: any) => ({
        name: item.name,
        color: item.itemStyle.color,
        percent: total ? Math.round((item.value / total) * 100) : 0,
      }));
      this.tizhiOption = {
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(6,20,40,0.92)",
          borderColor: "#1a6bb5",
          textStyle: { color: "#d7ecff", fontSize: 12 },
          formatter: (p: any) => p.name + " " + p.value + "（" + p.percent + "%）",
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "72%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: true,
            label: { show: false },
            labelLine: { show: false },
            data: sorted,
          },
        ],
      };
    }).catch(() => {
      this.tizhiLegend = [];
    }).then(() => {
      this.loading.tizhi = false;
    });
  }
  private getTizhiCountFallback() {
    if (this.kpi.tizhiCount) {
      return Promise.resolve();
    }
    const params: any = {
      ...this.baseParams(),
      统计时间: "全部时间",
    };
    return PostStatsNeirong(this, params).then((res: any) => {
      const list = (res && res.data) || [];
      const sum = list
        .filter((item: any) => String(item.title || item.name || "").indexOf("体质") > -1)
        .reduce((s: number, item: any) => s + this.toNumber(item.value), 0);
      if (sum) {
        this.kpi.tizhiCount = sum;
      }
    });
  }
  private getPopulation() {
    this.loading.people = true;
    this.hasAge = false;
    this.hasGender = false;
    return PostStatsPopulation(this, this.baseParams()).then((res: any) => {
      const ageList = (res && res["年龄分布"] && res["年龄分布"].data) || [];
      const ageTitles = (res && res["年龄分布"] && res["年龄分布"].title) || ageList.map((item: any) => item.title);
      const ageTotal = ageList.reduce((s: number, item: any) => s + this.toNumber(item.value), 0);
      this.hasAge = ageTotal > 0;
      const percents = ageList.map((item: any) => this.pickRatio(item, ageTotal));
      this.ageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          backgroundColor: "rgba(6,20,40,0.92)",
          borderColor: "#1a6bb5",
          textStyle: { color: "#d7ecff", fontSize: 12 },
          formatter: (params: any) => {
            const p = params && params[0];
            if (!p) {
              return "";
            }
            return p.name + "：" + p.value + "%";
          },
        },
        grid: { left: 8, right: 8, top: 28, bottom: 28, containLabel: true },
        xAxis: {
          type: "category",
          data: ageTitles,
          axisTick: { show: false },
          axisLine: { lineStyle: { color: "rgba(80,140,200,0.35)" } },
          axisLabel: { color: "#7aa0c4", fontSize: 10, interval: 0 },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100,
          splitNumber: 4,
          splitLine: { lineStyle: { color: "rgba(80,140,200,0.12)" } },
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: "#7aa0c4", fontSize: 10, formatter: "{value}%" },
        },
        series: [
          {
            type: "bar",
            barWidth: 16,
            data: percents.map((val: number, index: number) => ({
              value: val,
              itemStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: AGE_COLORS[index % AGE_COLORS.length] },
                    { offset: 1, color: "rgba(20,60,140,0.25)" },
                  ],
                },
              },
            })),
            label: {
              show: true,
              position: "top",
              color: "#9fd7ff",
              fontSize: 11,
              formatter: "{c}%",
            },
          },
        ],
      };

      const genderList = (res && res["性别分布"] && res["性别分布"].data) || [];
      const genderTotal = genderList.reduce((s: number, item: any) => s + this.toNumber(item.value), 0);
      this.hasGender = genderTotal > 0;
      const maleItem =
        genderList.find((item: any) => String(item.title || item.name || "").indexOf("男") > -1) || genderList[0] || {};
      const femaleItem =
        genderList.find((item: any) => String(item.title || item.name || "").indexOf("女") > -1) || genderList[1] || {};
      const male = this.pickRatio(maleItem, genderTotal);
      const female = this.pickRatio(femaleItem, genderTotal);
      this.genderPercents = { male, female };
      const genderData = [
        {
          name: "男",
          value: this.toNumber(maleItem.value) || male,
          itemStyle: { color: "#3d9eff" },
        },
        {
          name: "女",
          value: this.toNumber(femaleItem.value) || female,
          itemStyle: { color: "#3ecf9a" },
        },
      ];
      this.genderOption = {
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(6,20,40,0.92)",
          borderColor: "#1a6bb5",
          textStyle: { color: "#d7ecff", fontSize: 12 },
        },
        series: [
          {
            type: "pie",
            radius: ["32%", "78%"],
            center: ["50%", "52%"],
            label: { show: false },
            labelLine: { show: false },
            data: genderData,
          },
          {
            type: "pie",
            radius: ["32%", "66%"],
            center: ["50%", "52%"],
            silent: true,
            hoverAnimation: false,
            itemStyle: { color: "transparent", borderWidth: 0 },
            label: {
              show: true,
              position: "inside",
              color: "#fff",
              fontSize: 11,
              lineHeight: 15,
              formatter: (p: any) => {
                const pct = p.name === "男" ? male : female;
                return p.name + "\n" + pct + "%";
              },
            },
            labelLine: { show: false },
            data: genderData.map((item) => ({
              name: item.name,
              value: item.value,
              itemStyle: { color: "transparent", borderWidth: 0 },
            })),
          },
        ],
      };
    }).catch(() => {
      this.hasAge = false;
      this.hasGender = false;
    }).then(() => {
      this.loading.people = false;
    });
  }
  private getFeed() {
    this.loading.feed = true;
    return GetDapinData(this, { hospital_ids: [] }).then((data: any) => {
      this.messagesList = Array.isArray(data) ? data : [];
    }).catch(() => {
      this.messagesList = [];
    }).then(() => {
      this.loading.feed = false;
    });
  }
  private getTongueFeatureData() {
    this.loading.feature = true;
    return getTongueFeature(this, {}).then((res: any) => {
      const data = res || {};
      this.featureGroups = FEATURE_KEYS.map((key) => {
        const group = data[key] || {};
        const list = Array.isArray(group.data) ? group.data : [];
        const total = list.reduce((s: number, item: any) => s + this.toNumber(item.value), 0);
        return {
          title: key,
          color: FEATURE_COLORS[key],
          items: list.map((item: any) => ({
            name: item.name,
            percent: this.pickRatio(item, total),
          })),
        };
      }).filter((group) => group.items.length);
    }).catch(() => {
      this.featureGroups = [];
    }).then(() => {
      this.loading.feature = false;
    });
  }
  private refresh() {
    this.updateTime = new Date();
    this.loading.kpi = true;
    Promise.all([
      this.getServiceKpi(),
      this.getAssessKpi(),
      this.getHospitalCount(),
      this.getTizhi().then(() => this.getTizhiCountFallback()),
    ]).catch(() => undefined).then(() => {
      this.loading.kpi = false;
    });
    this.getTongueFeatureData();
    this.getTrend();
    this.getPopulation();
    this.getFeed();
    this.waitToRefresh();
  }
  private waitToRefresh() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
    }
    this.refreshTimer = setTimeout(() => {
      this.refresh();
    }, 1000 * 60 * 10);
  }
  private mounted() {
    this.interval = setInterval(() => {
      this.nowTime = new Date();
    }, 1000);
    this.refresh();
  }
  private destroyed() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
    }
  }
}
